import MainLayout from "../../layout/MainLayout";
import { ToggleButton, QuickActionSelect } from "../index";
import rightArrow from "../../assets/icons/chevron-right.png";
import doubleRightArrow from "../../assets/icons/chevron-right-double.png";
import leftArrow from "../../assets/icons/chevron-left.png";
import doubleLeftArrow from "../../assets/icons/chevron-left-double.png";

const SHORT_MONTHS = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
];

// Last 12 months ending at current month, formatted as "MMM-YY".
export const buildMonthOptions = (now = new Date()) => {
  const out = [];
  for (let i = 11; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    out.push(`${SHORT_MONTHS[d.getMonth()]}-${String(d.getFullYear()).slice(-2)}`);
  }
  return out;
};

export const currentMonthOption = (now = new Date()) =>
  `${SHORT_MONTHS[now.getMonth()]}-${String(now.getFullYear()).slice(-2)}`;

const ManageMySpending = ({
  navName,
  children,
  showQuickAction = true,
  selectedMonth,
  onMonthChange,
  pageClassName = "",
  contentClassName = "",
}) => {
  const monthOptions = buildMonthOptions();

  // Helper to find full month name from short name
  const getFullMonthName = (shortWithYear) => {
    if (!shortWithYear) return "February";
    const [short] = shortWithYear.split("-");
    const monthMap = {
      "JAN": "January", "FEB": "February", "MAR": "March", "APR": "April",
      "MAY": "May", "JUN": "June", "JUL": "July", "AUG": "August",
      "SEP": "September", "OCT": "October", "NOV": "November", "DEC": "December"
    };
    return monthMap[short.toUpperCase()] || short;
  };

  return (
    <>
      <MainLayout
        expand={false}
        NavName={navName}
        pageClassName={pageClassName}
        contentClassName={contentClassName}
        navbarChildren={
          showQuickAction && (
            <QuickActionSelect />
          )
        }
      >
        <div>
          <div className="container">
            <div className="d-flex justify-content-md-between justify-content-center align-items-center flex-wrap flex-md-nowrap ">
              <div className="d-flex gap-3 align-items-center">
                <span className="fs-5 fw-semibold ">{getFullMonthName(selectedMonth)}</span>

                <div className="d-flex gap-2 align-items-center align-self-end">
                  <img
                    src={doubleLeftArrow}
                    alt="doubleLeft"
                    className="cursor-pointer"
                    onClick={() => onMonthChange && onMonthChange(monthOptions[0])}
                  />
                  <img
                    src={leftArrow}
                    alt="left"
                    className="cursor-pointer"
                    onClick={() => {
                      const idx = monthOptions.indexOf(selectedMonth);
                      if (idx > 0 && onMonthChange) onMonthChange(monthOptions[idx - 1]);
                    }}
                  />
                  <img 
                    src={rightArrow} 
                    alt="right" 
                    className="cursor-pointer" 
                    onClick={() => {
                      const idx = monthOptions.indexOf(selectedMonth);
                      if (idx < monthOptions.length - 1 && onMonthChange) onMonthChange(monthOptions[idx + 1]);
                    }}
                  />
                  <img
                    src={doubleRightArrow}
                    alt="doubleRight"
                    className="cursor-pointer"
                    onClick={() => onMonthChange && onMonthChange(monthOptions[monthOptions.length - 1])}
                  />
                </div>
              </div>

            </div>

            <div className="mt-3">
              <ToggleButton
                block={true}
                options={monthOptions}
                value={selectedMonth}
                onChange={onMonthChange}
              />
            </div>

            {children}
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default ManageMySpending;
